import React, { useCallback } from 'react'
import { SelectRoleStyles } from './Style'
import { RemoveDefaultRoleBtn, roleHooks, SelectDefaultRoleBtn } from '.'
import { countBy } from 'lodash'
import { Img } from 'styles/GlobalStyle'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'

const SelectRole = () => {
    const { user } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { user_data, default_user_roles } = user || {}

    const roleList = roleHooks.useRoleList()
    const selectRole = roleHooks.useSelectRole()

    const selectCurrentRole = useCallback((role) => {
        if (!default_user_roles) return

        else {
            selectRole(role)
            navigate(app.app)
        }
    }, [])

    return (
        <SelectRoleStyles>
            <div className='wrap-title'>
                <div className='title'>
                    {"מה הכובע שלי עכשיו?"}
                </div>
                <div className='wrap-sub-title'>
                    <div className='sub-title'>
                        {"פרופילים שונים עוזרים להפריד בין התפקידים."}
                    </div>
                    <div className='sub-title'>
                        {"המערכת משתנה בהתאם לתפקיד."}
                    </div>
                </div>
            </div>
            <div className='role-cards'>
                {user_data?.map((role) => {
                    const { role_name, role_label, user_roles, affiliation_name } = role

                    return (
                        <div className='role-item' onClick={() => selectCurrentRole(role)}>
                            <div className='role-img'>
                                <Img src={roleList[role_name]?.icon || roleList["default"].icon} />
                            </div>
                            <div className='role-label three-dots one-line'>
                                {role_label}
                            </div>
                            <div className='affiliation-name'>{affiliation_name}</div>

                            {default_user_roles != user_roles &&
                                <SelectDefaultRoleBtn role={role} />
                            }
                            {default_user_roles == user_roles &&
                                <RemoveDefaultRoleBtn />
                            }
                        </div>
                    )
                }
                )}
            </div>
        </SelectRoleStyles>
    )
}

export default SelectRole